import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import { transitionTo } from 'pds-witsmlstudio-core/helpers';
import { Permissions } from 'pds-witsmlstudio-core/components';
import PageLayout from '../components/page-layout';

<template>
  {{pageTitle (t "permissions.title")}}

  <PageLayout>
    <:content>
      <Permissions @onClose={{transitionTo "index"}} />
    </:content>
  </PageLayout>
</template>
